import React from 'react';
import PropTypes from 'prop-types';
import strings from '../locales/';

const PermitsDisplay = props => {
  var permitsText = (
      <div className={'permits-display-wrapper'}>
        {props.language.user_profile.detail.isAdmin}
      </div>
    );

  if(props.isAdmin == false) {
    permitsText = (
      <div className={'permits-display-wrapper'}>
        {props.permits.map((item, i) => (
          <div key={i}>
            {props.language.account.accountUser[item.toLowerCase()]}
          </div>
        ))}
      </div>
    );
  } 

  return permitsText;
};

export default PermitsDisplay;



// WEBPACK FOOTER //
// ./source/client/components/user_profile/permitsDisplay.jsx